export default __webpack_public_path__ + "static/media/Mark-6-HUD-Footer.2411bf29.jpg";